/*
 * CVR改善 Item 4 拡張: 商品ページの発送目安を選択中variantに応じて更新する。
 *
 * 設計方針:
 * - Dawn標準の assets/product-info.js は変更しない。
 * - 同ファイルが同一variant内でのオプション変更時に発行する
 *   PUB_SUB_EVENTS.variantChange (assets/pubsub.js / constants.js は無変更) を
 *   独立して購読するだけで完結させる。
 * - 発送目安の判定（「納期」オプションの値の解釈）はサーバー側の
 *   snippets/cvr-product-assurance.liquid が行う。このファイルは
 *   再取得済みHTML内の該当要素をそのまま差し替えるだけで、判定ロジックは持たない。
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    var sectionId = event && event.data && event.data.sectionId;
    var html = event && event.data && event.data.html;
    if (!sectionId || !html || typeof html.getElementById !== 'function') return;

    var target = document.getElementById('CvrDeliveryEstimate-' + sectionId);
    var source = html.getElementById('CvrDeliveryEstimate-' + sectionId);
    if (!target || !source) return;

    target.innerHTML = source.innerHTML;
  });
})();
